<template>
	<label :class="switchClass" class="d21-switch">
		<div :class="checkmarkClass"></div>
		<div v-for="item in items" :key="item.value" v-on:click="select(item)" :class="itemClass(item)">
			<img v-if="item.image" :src="item.image" :class="item.imageClasses" />
			<span v-if="!item.image" :class="{ 'singleLine': item.subText === null }">
				<i v-if="item.icon" class="material-icons">{{item.icon}}</i>
				{{item.text}}
				<span v-if="item.subText">{{item.subText}}</span>
			</span>
		</div>
	</label>
</template>

<script>
	export default {
		name: "d21-switcher",
		props: ["items", "disabled"],
		data() {
			return {
				selectedItem: null
			};
		},
		computed: {
			switchClass() {
				const classes = ["d21-switch--" + this.items.length];
				if (this.disabled) {
					classes.push("d21-switch--disabled");
				}
				return classes;
			},
			checkmarkClass() {
				var index = this.selectedItem === null ? 0 : this.items.map(x => x.value).indexOf(this.selectedItem.value);
				return "checkmark checkmark--" + index;
			}
		},
		mounted() {
			this.selectedItem = this.items.find(i => i.isSelected);
			if (!this.selectedItem) this.select(this.items[0]);
		},
		methods: {
			itemClass(item) {
				return item.isSelected ? "d21-switch-labels d21-switch-labels--selected" : "d21-switch-labels";
			},
			select(item) {
				if (this.disabled) return this.$emit("disabledClick");
				if (this.selectedItem) this.selectedItem.isSelected = false;
				this.selectedItem = item;
				this.selectedItem.isSelected = true;
				this.$emit("input", this.selectedItem);
			}
		},
		watch: {
			'items'(newValue) {
				this.selectedItem = this.items.find(i => i.isSelected);
				if (!this.selectedItem) this.select(this.items[0]);
			}
		}
	};
</script>